<template>
       <div class="ccpay-orderSates"  style="height:100%" >
               <iframe v-show="playflag" src = "https://ccpaycommonfile.s3.ap-northeast-1.amazonaws.com/voice/order_voice_notify.mp3" hidden="true" allow = "autoplay"/>
                <div class="ccpay-order-tab">
                    <div @click="changeActive(1)">
                        <span :class="isactive==1?'class-tab-sp':''" >需处理&nbsp;{{componlist.length}}</span>
                    </div>
                    <div @click="changeActive(2)">
                         <span :class="isactive==2?'class-tab-sp':''">进行中&nbsp;{{peddinglist.length}}</span>
                    </div>
                </div>
                  <div style="height:3rem" ></div>
         <mt-loadmore :top-method="loadTop"   ref="loadmore" style="background:white">
               <div class="ccpay-order-content" style="height:auto;flex:1" v-show="isactive==1">
                    <div class="ccapy-order-card" v-for='(item,index) in componlist' :key="index"  @click="detail(item.order_no)" >
                        <div class="ccpay-cls-act-div" v-show="item.isclass"></div>
                            <p class="ccpay-order-card-hed fz14"><span>
                                <span class="c-r-c-g fw-60"  :style="{'color':item.side=='BUY'?'#54BCA5':'#CA595B'}" style="margin-right">
                                {{item.side=='BUY'?'买-' + item.kyc_name :'卖-' + item.kyc_name }} </span>
                                </span>
                                <span v-show="item.side=='BUY'" class="c-r-c-g fw-60">已付款 {{dataArr.length>0?dataArr[index]:''}}</span>
                                <span v-else class="c-r-c-br fw-60">{{dataArr.length>0?dataArr[index]:''}} </span>
                            </p>
                            <p class="ccpay-order-c-spbed fz14"    >
                                <span>{{moment(item.created_time).format("MM-DD HH:mm")}}</span>
                                <span  style="float:right">¥ {{toFixed(item.legal_amount,2)}}</span>
                            </p>
                        </div>
                </div>
                 <div class="ccpay-order-content" style="height:auto;flex:1" v-show="isactive==2">
                    <div class="ccapy-order-card" v-for='(item,index) in peddinglist' :key="index" @click="detail(item.order_no)" >
                        <div class="ccpay-cls-act-div" v-show="item.isclass"></div>
                            <p class="ccpay-order-card-hed fz14"><span>
                                <span class="c-r-c-g fw-60"  :style="{'color':item.side=='BUY'?'#54BCA5':'#CA595B'}" style="margin-right">
                                {{item.side=='BUY'?'买-' + item.kyc_name :'卖-' + item.kyc_name }} </span>
                                </span>
                                <span v-show="item.side=='BUY'" class="c-r-c-g fw-60">未付款：{{dataArr2.length>0?dataArr2[index]:''}}</span>
                                <span v-else class="c-r-c-br fw-60">{{dataArr2.length>0?dataArr2[index]:''}} </span>
                            </p>
                            <p class="ccpay-order-c-spbed fz14"    >
                                <span>{{moment(item.created_time).format("MM-DD HH:mm")}}</span>
                                <span  style="float:right">¥ {{toFixed(item.legal_amount,2)}}</span>
                            </p>
                        </div>
                </div>
               
         </mt-loadmore>
       </div>
</template>
<script>
import {toFixed} from '../../public/index.js'
import Scroll from "@/component/scroll";
import moment from  "moment"
import {Indicator, Loadmore} from 'mint-ui';

export default {
     data(){
        return {
            data:[],//初始数据
            restTimer:null,//已付款倒计时
            dataArr:[],//倒计时数组
            restTimer2:null,//进行中倒计时
            dataArr2:[],//倒计时数组

            playflag:false,//是否有新订单
            isactive:1,//区分订单
            componlist:[], //付款订单
            peddinglist:[],//未付款订单
        }
    },
      mounted(){
 
        this.onPullingDown()
        this.audiotimelist()
    },
      destroyed(){
         clearInterval(this.audiotimer)
         clearInterval(this.restTimer)
          clearInterval(this.restTimer2)
    },
    methods:{
        toFixed,
        moment,
        //下拉刷新
        loadTop() {
            setTimeout(()=>{
                 this.data = []
                 this.componlist = []
                 this.peddinglist = []
                  clearInterval(this.restTimer)
                  clearInterval(this.restTimer2)
                  this.onPullingDown()
                  this.$refs.loadmore.onTopLoaded();
            },1000)
        },
         // 当音频播放
        audiotimelist(){
            this.audiotimer = setInterval(()=>{
                this.$axios.get(`/v1/traders/order/list/pedding?page=1&per_page=1000&order=0`).then(res=>{
                    if(res.code==0){
                             this.data = []
                            this.componlist = []
                            this.peddinglist = []
                            clearInterval(this.restTimer)
                            clearInterval(this.restTimer2)
                             this.data =  res.data
                            this.isclassId(this.data)
                            this.classification()
                          let neworder_no =    moment(res.data[0].created_time).valueOf()
                          let order_no = window.localStorage.getItem('order_no')
                          console.log(neworder_no>Number(order_no))
                          if(order_no){
                            //  console.log(neworder_no>Number(order_no),neworder_no,Number(order_no))
                                if(neworder_no>Number(order_no)){
                                    this.$ModelToast(true)
                                    this.playflag = true
                                    window.localStorage.setItem('order_no',neworder_no)
                                    setTimeout(() => {
                                        this.playflag = false
                                    }, 4000);
                                }
                            }else{
                                window.localStorage.setItem('order_no',neworder_no)
                            }
                    }
                 })
            },20000)
        },
        //初始化数据
        onPullingDown(){
             Indicator.open();
             this.$axios.get(`/v1/traders/order/list/pedding?page=1&per_page=1000&order=0`).then(res=>{
                    Indicator.close();
                    if(res.code==0){
                        this.data =  res.data
                        this.isclassId(this.data)
                        this.classification()
                      
                        console.log( this.data,' this.data')
                    }
             })
        },
        //分类
        classification(){
            this.componlist = []
            this.peddinglist = []

            this.data.forEach((item,index)=>{
                // console.log(item)
                if(item.side=='BUY'){
                       if(item.status=='PAID'){
                                this.componlist.push(item)
                        }else{
                                this.peddinglist.push(item)
                        }
                 }else{
                        this.componlist.push(item)
                 }
            })
             this.setIntervalTime(this.componlist,1)
             this.setIntervalTime(this.peddinglist,2)
          
            // this.setIntervalTime(this.peddinglist)
        },
        //倒计时
        setIntervalTime(data,idx){
            console.log(data,idx)
            if(idx==1){
               
      
                 this.restTimer =    setInterval(() => {
                    this.dataArr = []
                    data.forEach(item => {
                            this.dataArr.push(this.restTime(item.plan_end_time))
                    })
                }, 1000)
                 console.log(this.dataArr)
            }else{
                  
                this.restTimer2 =    setInterval(() => {
                    this.dataArr2 = []
                    data.forEach(item => {
                            this.dataArr2.push(this.restTime(item.plan_end_time))
                    })
                }, 1000)
                console.log(this.dataArr2)
            }
            
        },
        //处理倒计时
        restTime:function(time){
                 var settime = moment(time).valueOf()
                 var nowtime = moment().valueOf()
                 var restsec = settime - nowtime
                 if(restsec<0){
                     return '已超时';
                 }
                 var minu = parseInt((restsec / (60 * 1000)) % 60);
                 var sec = parseInt((restsec / 1000) % 60);
                 return minu + ":" + this.zero(sec);
        },
        //处理0
         zero(sec) {
            if (sec < 10) {
                return "0" + sec;
            } else {
                return sec;
            }
        },
        //是否点击
        isclassId(data){
            let styList = JSON.parse(window.localStorage.getItem('styList'))
             if(!styList){
                styList = []
             }
            data.forEach((item,index)=>{
                if(styList.indexOf(item.order_no)==-1){
                    item.isclass = true
                }else{
                    item.isclass = false
                }
                
            })
        },
        detail(id){
            let styList = window.localStorage.getItem('styList')
            if(!styList){
                let newarr = [id]
                window.localStorage.setItem('styList',JSON.stringify(newarr))
            }else{
                 let newlist = window.localStorage.getItem('styList')
                 let arr = JSON.parse(newlist)
                //    console.log(arr,'shi')
                 if(arr.indexOf(id)==-1){
                       arr.push(id)
                 }else{
                    //  console.log('问问哟')
                 }
                 window.localStorage.setItem('styList',JSON.stringify(arr))
            }
            // styList.push(id)
            this.$router.push({
                path:'/orderdetail',
                query:{orderid:id}
            })
        },
        //切换数据
        changeActive(idx){
            this.isactive = idx
        }
    }
}
</script>


<style lang="scss" scoped>
    .ccpay-orderSates{
        // padding-bottom:3rem;
    }
    .ccpay-order-tab{
            font-weight: 500;
             position: fixed;
            top: 0;
            z-index: 999;
            height: 3rem;
            line-height: 3rem;
            width: 100%;
            // padding: 1rem;
            background: white;
            display: flex;
            // padding-left:2rem;
            justify-content: space-around;
            border-bottom:1px solid #ccc;
            padding-bottom:0.2rem;
            div{
                // flex: 1;
                // margin-right: 3rem;
                text-align: center;
                .class-tab-sp{
                    background: #20ABFE;
                    padding: 8px;
                    padding-left: 16px;
                    padding-right: 16px;
                    color: white;
                    font-size: 14px;
                    border-radius: 10px;
                    
                }
            }
    }
    .ccpay-order-content{
            padding:1rem;
            // padding-bottom: 0;
              padding-bottom:6rem;
    }
    .ccapy-order-card{
            color: #666666;
            -webkit-transform: translateZ(0px);
            transform: translateZ(0px);
            font-size: 14px;
            // -webkit-box-shadow: rgba(0, 0, 0, 0.12) 0px 4px 16px;
            // box-shadow: rgba(0, 0, 0, 0.12) 0px 4px 16px;
            // border-radius: 8px;
            // transition: transform 500ms cubic-bezier(0.12, 0.72, 0.29, 1) 0s, -webkit-transform 500ms cubic-bezier(0.12, 0.72, 0.29, 1) 0s;
            border-bottom: 1px solid #ccc;
            position: relative;
            padding: 1.5rem;
            padding-bottom: 0.01rem;
            p{
                margin-bottom: 1rem;
            }
           .ccpay-order-card-hed{
                display: flex;
                justify-content: space-between;
                span{
                    // margin-right: .8rem;
                    font-size: 0.9rem;
                    // font-size: 1rem;
                }
                .c-o-bg-r{
                    color: #E08DA1;
                    background: #FFF7FA;
                    padding: 7px;
                    border-radius: 10px;
                }
                .c-r-c-g{
                    color: #54BCA5;
                    
                }
                .c-r-c-b{
                    color:black;
                }
                .c-r-c-br{
                    color:#CA595B;
                    margin-right: 0;
                    // font-weight: 600;
                }
           }
            background: white;
            .ccpay-order-c-spbed{
                display: flex;
                justify-content: space-between;
            }
            .ccpay-order-c-canle{
                background: #20ABFE;
                padding: 6px;
                border: none;
                padding-left: 1rem;
                padding-right: 1rem;
                color: white;
                border-radius: 2px;
            }
    }
    .ccpay-cls-act-div{
                position: absolute;
                width: 100%;
                height: 100%;
                background: gold;
                opacity: 0.2;
                top: 0;
                left: 0;
        }
</style>


// WEBPACK FOOTER //
// src/components/index/Orderlist.vue